'use client'

import s from './page.module.scss';
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import {Title} from "@/app/[locale]/common/components/Title/Title";
import Image from "next/image";
import warranty_services_top
    from "@/app/[locale]/common/assets/images/services/warranty-services/warranty-services.webp";
import {Button} from "@/app/[locale]/common/components/Button/Button";
import {TServicesCardsContentIcon, WarrantyServicesPageProcessBlockData} from "@/app/[locale]/services/types";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {LineArrowIcon} from "@/app/[locale]/common/assets/LineArrowIcon/LineArrowIcon";
import {DottedLine} from "@/app/[locale]/common/assets/DottedLine/DottedLine";
import {ELEMENT_INDEX} from "../../common/constants/app";
import {ModalWindow} from "@/app/[locale]/common/components/ModalWindow/ModalWindow";
import {useState} from "react";
import {
    ContactUsModalWindowContent
} from "@/app/[locale]/common/components/ContactUsModalWindowContent/ContactUsModalWindowContent";
import {useTranslations} from "next-intl";
import {
    addDataToTranslatedArray
} from "@/app/[locale]/common/utils/functions/addDataToTranslatedArray/addDataToTranslatedArray";
import {TechnotonLogoIcon} from "@/app/[locale]/common/assets/TechnotonLogoIcon/TechnotonLogoIcon";
import {CertificateIcon} from "@/app/[locale]/common/assets/CertificateIcon/CertificateIcon";
import {ManPhoneIcon} from "@/app/[locale]/common/assets/ManPhoneIcon/ManPhoneIcon";
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import {NumOneCircleIcon} from "@/app/[locale]/common/assets/NumOneCircleIcon/NumOneCircleIcon";
import {NumTwoCircleIcon} from "@/app/[locale]/common/assets/NumTwoCircleIcon/NumTwoCircleIcon";
import {NumTreeCircleIcon} from "@/app/[locale]/common/assets/NumTreeCircleIcon/NumTreeCircleIcon";
import {NumFourCircleIcon} from "@/app/[locale]/common/assets/NumFourCircleIcon/NumFourCircleIcon";
import {NumFiveCircleIcon} from "@/app/[locale]/common/assets/NumFiveCircleIcon/NumFiveCircleIcon";
import {QualityIcon} from "@/app/[locale]/common/assets/QualityIcon/QualityIcon";
import {TimeTrackingIcon} from "@/app/[locale]/common/assets/TimeTrackingIcon/TimeTrackingIcon";

export default function WarrantyServicesPage() {
    const t = useTranslations('WarrantyServicesPage');
    const aboutBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('aboutBlock.cardsData'), [TechnotonLogoIcon, CertificateIcon, ManPhoneIcon], 'Icon');
    const ourServicesBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('ourServicesBlock.cardsData'), [ConfirmIcon, ConfirmIcon, ConfirmIcon, ConfirmIcon], 'Icon');
    const processBlockListData: WarrantyServicesPageProcessBlockData[] = addDataToTranslatedArray(t.raw('processBlock.list'), [NumOneCircleIcon, NumTwoCircleIcon, NumTreeCircleIcon, NumFourCircleIcon, NumFiveCircleIcon], 'icon');
    const benefitsBlockCardsData: TServicesCardsContentIcon[] = addDataToTranslatedArray(t.raw('benefitsBlock.cardsData'), [CertificateIcon, QualityIcon, ManPhoneIcon, TimeTrackingIcon], 'Icon');

    const [ isOpenModalWindow, setIsOpenModalWindow ] = useState(false);
    const openModalWindow = () => setIsOpenModalWindow(true);
    const closeModalWindow = () => setIsOpenModalWindow(false);

    return (
        <div className={s.warrantyServices}>
            <Container>
                <Breadcrumbs crumb={[t.raw('breadcrumbs.SERVICES'), t.raw('breadcrumbs.WARRANTY_SERVICES')]} />

                <div className={s.warrantyServices_top}>
                    <Title title={t('title')}/>

                    <div className={s.warrantyServices_flexContainer}>
                        <div className={s.warrantyServices_imageContainer}>
                            <Image src={warranty_services_top} alt={'warranty_services_top'}/>
                        </div>

                        <div className={s.warrantyServices_top_content}>
                            <p className={s.warrantyServices_text} dangerouslySetInnerHTML={{__html: t.raw('topBlock.text')}} />
                            <p className={s.warrantyServices_text}>{t('topBlock.secondText')}</p>
                            <Button size={'medium'} className={s.warrantyServices_top_buttonDesktop} onClick={openModalWindow}>{t('topBlock.button')}</Button>
                            <Button size={'mobile'} className={s.warrantyServices_top_buttonMobile} onClick={openModalWindow}>{t('topBlock.button')}</Button>
                        </div>
                    </div>
                </div>

                <div className={s.warrantyServices_about}>
                    <Title title={t('aboutBlock.title')} />

                    <div className={s.warrantyServices_flexContainer}>
                        {
                            aboutBlockCardsData.map(( item: TServicesCardsContentIcon, index: number ) => (
                                <div key={index} className={`${s.warrantyServices_card} ${s.warrantyServices_about_card} ${index === 0 ? s.warrantyServices_about_cardLeft : ''} ${index === 1 ? s.warrantyServices_about_cardMedium : ''} ${index === 2 ? s.warrantyServices_about_cardRight : ''}`}>
                                    <div className={`${index === ELEMENT_INDEX.FIRST ? s.warrantyServices_about_technotonIconContainer : s.warrantyServices_iconContainer}`}>
                                        { <item.Icon /> }
                                    </div>
                                    <label className={s.warrantyServices_label}>{ item.label }</label>
                                    <p className={s.warrantyServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.warrantyServices_ourServices}>
                    <Title title={t('ourServicesBlock.title')} />

                    <p className={`${s.warrantyServices_text} ${s.warrantyServices_textBlock}`}>{t('ourServicesBlock.text')}</p>

                    <div className={s.warrantyServices_gridContainer}>
                        {
                            ourServicesBlockCardsData.map((item: TServicesCardsContentIcon, index: number) => (
                                <div key={index} className={s.warrantyServices_card}>
                                    <div className={s.warrantyServices_ourServices_container}>
                                        {<item.Icon/>}
                                        <label className={s.warrantyServices_label}>{item.label}</label>
                                    </div>
                                    <p className={s.warrantyServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={s.warrantyServices_process}>
                    <Title title={t('processBlock.title')}/>

                    <div className={s.warrantyServices_process_container}>
                        {processBlockListData.map(({ icon: Icon, label, description, hasArrow }: WarrantyServicesPageProcessBlockData, index: number) => (
                            <div key={index} className={s.warrantyServices_process_block}>
                                <div className={s.warrantyServices_process_block_top}>
                                    <div className={s.warrantyServices_process_iconContainer}>
                                        <Icon />
                                    </div>
                                    {hasArrow && <div className={s.warrantyServices_process_arrowLine}><LineArrowIcon /></div>}
                                </div>
                                <label className={s.warrantyServices_text}>{label}</label>
                                <p className={`${s.warrantyServices_text} ${s.warrantyServices_process_block_text}`}>{description}</p>
                                {
                                    index < ELEMENT_INDEX.FIFTH &&
                                    <div className={s.warrantyServices_process_block_line}>
                                        <DottedLine/>
                                    </div>
                                }
                            </div>
                        ))}

                        <div className={`${s.warrantyServices_process_arrowLine} ${s.warrantyServices_process_arrowLineTop}`}>
                            <LineArrowIcon long={true} />
                        </div>
                        <div className={`${s.warrantyServices_process_arrowLine} ${s.warrantyServices_process_arrowLineBottom}`}>
                            <LineArrowIcon long={true}/>
                        </div>
                    </div>
                </div>

                <div className={s.warrantyServices_benefits}>
                    <Title title={t('benefitsBlock.title')}/>
                    <p className={`${s.warrantyServices_text} ${s.warrantyServices_textBlock}`}>
                        {t('benefitsBlock.text')}
                    </p>

                    <div className={s.warrantyServices_flexContainer}>
                        {
                            benefitsBlockCardsData.map((item: TServicesCardsContentIcon, index: number) => (
                                <div key={index}
                                     className={`${s.warrantyServices_card} ${s.warrantyServices_benefits_card}`}>
                                    <div
                                        className={`${s.warrantyServices_iconContainer} ${s.warrantyServices_benefits_iconContainer}`}>{
                                        <item.Icon/>}</div>

                                    <label>{ item.label }</label>
                                    <p className={s.warrantyServices_text}>{ item.text }</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <Title title={t('contacts.title')} />
                <p className={`${s.warrantyServices_contactText} ${s.warrantyServices_text} ${s.warrantyServices_textBlock}`}>{ t('contacts.text') }</p>
                <ContactUs title={false} />

                <ModalWindow isOpen={isOpenModalWindow} closeModalWindow={closeModalWindow}>
                    <ContactUsModalWindowContent />
                </ModalWindow>
            </Container>
        </div>
    );
};